import { clearPhoneNumber } from '@gem/utils';

import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

export interface IPhoneNumberValidateParams extends IFieldValidationParams {
  data: {
    phoneTemplate?: string;
  };
}

export const phoneNumberCheckValidation = ({
  value = '',
  errorToText,
  data: { phoneTemplate },
}: IPhoneNumberValidateParams): string | null => {
  const phone = '+' + clearPhoneNumber(value);
  if (
    phone === '+' ||
    (phoneTemplate && phone.length - 1 < phoneTemplate.replace(/[^X]/g, '').length - 1)
  ) {
    return errorToText[ValidationErrorType.PhoneInvalid] || '';
  }
  return null;
};
